import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { ActionWithPayload } from "@obg/ngrx-utils";
import { AppError } from "@obg/ngx.core";

export const ACTION_PREFIX = "[Registration With BankID]";

export const REGISTRATION_WITH_BANK_ID_ACTION_TYPE = {
	getBankIdRegistrationUrl: `${ACTION_PREFIX} Get BankID Registration URL`,
	getBankIdRegistrationUrlSuccess: `${ACTION_PREFIX} Get BankID Registration URL Success`,
	getBankIdRegistrationUrlFail: `${ACTION_PREFIX} Get BankID Registration URL Fail`,
};

@Injectable({
	providedIn: "root",
})
export class RegistrationWithBankIdAction {
	getBankIdRegistrationUrl(): Action {
		return {
			type: REGISTRATION_WITH_BANK_ID_ACTION_TYPE.getBankIdRegistrationUrl,
		};
	}

	getBankIdRegistrationUrlSuccess(payload: string): ActionWithPayload {
		return {
			type: REGISTRATION_WITH_BANK_ID_ACTION_TYPE.getBankIdRegistrationUrlSuccess,
			payload,
		};
	}

	getBankIdRegistrationUrlFail(payload: AppError): ActionWithPayload {
		return {
			type: REGISTRATION_WITH_BANK_ID_ACTION_TYPE.getBankIdRegistrationUrlFail,
			payload,
		};
	}
}
